import { Type } from '@sinclair/typebox';
import { IsoDateTimeSchema, UuidSchema } from './common.js';
/**
 * Shared contracts for durable executions (COP-160 D1; AGENT-09).
 *
 * One `tf_execution` row per plan or scheduled run the hub executes; one
 * `tf_execution_step` row per plan step. The literal unions below are the wire
 * mirrors of the `tf_execution_kind`, `tf_execution_status` and
 * `tf_execution_step_status` pg enums — same members, same order.
 */
export const ExecutionKindSchema = Type.Union([Type.Literal('plan'), Type.Literal('scheduled')]);
export const ExecutionStatusSchema = Type.Union([
    Type.Literal('running'),
    Type.Literal('waiting_job'),
    Type.Literal('waiting_approval'),
    Type.Literal('paused'),
    Type.Literal('succeeded'),
    Type.Literal('failed'),
]);
export const ExecutionStepStatusSchema = Type.Union([
    Type.Literal('pending'),
    Type.Literal('running'),
    Type.Literal('awaiting_job'),
    Type.Literal('awaiting_approval'),
    Type.Literal('succeeded'),
    Type.Literal('failed'),
    Type.Literal('not_run'),
]);
export const ExecutionIdParamsSchema = Type.Object({ id: UuidSchema });
/** The execution row as its owner reads it. */
export const ExecutionDtoSchema = Type.Object({
    id: UuidSchema,
    sessionId: UuidSchema,
    userId: UuidSchema,
    trackId: UuidSchema,
    kind: ExecutionKindSchema,
    planId: Type.Union([UuidSchema, Type.Null()]),
    scheduledRunId: Type.Union([UuidSchema, Type.Null()]),
    status: ExecutionStatusSchema,
    cursor: Type.Integer(),
    waitingOn: Type.Union([Type.String(), Type.Null()]),
    pausedFrom: Type.Union([ExecutionStatusSchema, Type.Null()]),
    turns: Type.Integer(),
    computeMs: Type.Integer(),
    error: Type.Union([Type.String(), Type.Null()]),
    startedAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
    finishedAt: Type.Union([IsoDateTimeSchema, Type.Null()]),
});
export const ExecutionTransitionResponseSchema = Type.Object({ status: ExecutionStatusSchema });
/** The three `409` codes of the execution pause / resume routes (COP-160 P50). */
export const ExecutionConflictResponseSchema = Type.Object({
    error: Type.Union([
        Type.Literal('execution_terminal'),
        Type.Literal('execution_running'),
        Type.Literal('execution_not_paused'),
    ]),
    message: Type.String(),
});
//# sourceMappingURL=executions.js.map